import { getNotes, SUBMIT_NOTE_ACTION_TYPES } from 'utils/actions/notes'

/**
 * @description Refetches notes for noteable entity when a note is successfully submitted.
 */
export const notes = store => next => async action => {
  if (action.type !== SUBMIT_NOTE_ACTION_TYPES.SUBMIT_NOTE_SUCCESS) return next(action)
  const { body, getNotesParams = {} } = action.payload.requestData
  // override noteableId and noteableType when getNotesParams is provided
  const noteableId = getNotesParams.noteableId ?? body.note.noteableId
  const noteableType = getNotesParams.noteableType ?? body.note.noteableType
  const { noteType = 'human' } = action.payload.requestData.params.filters
  return store.dispatch(getNotes(noteableId, noteableType, noteType))
}
